import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-urc-pill',
	templateUrl: './urc-pill.component.html',
	styleUrls: ['./urc-pill.component.scss'],
})
export class UrcPillComponent {
	@Input() text = "This Product Must Be Scanned";

	get ariaLabel(): string {
		return this.text;
	}
}
